import { getLoadings } from '@shakkerai/pro-store';
import { getImageOssPath, getCDNImage } from '@shakkerai/util-image';
import { generateMask, inferenceAPIBucket } from '@shakkerai/pro-utils';
import { requestSmartRemoveImage } from '@shakkerai/services';
import { notifySuccess, notifyError } from '@shakkerai/pro-components';
import { updateElement } from '@starflow/app/helpers/canvas';
import { translate } from '@shakkerai/util-i18n';

export const smartRemoveShapesFromImage = async (element, selections) => {
  const { startLoading, stopLoading } = getLoadings();
  const isRemoving = getLoadings(element.id + '-removing');

  if (isRemoving) return;

  startLoading(element.id + '-removing');

  try {
    const maskImageId = await generateMask(element, {
      fixPoints: true,
      segments: { selections },
      bgTransparent: true,
      toTempBucket: false,
    })
      .then(getImageOssPath)
      .catch((e) => {
        console.error('generateMask error', e);
      });
    // 请求智能擦除接口（imageSmartRemove），接口返回生成后的图片url
    const { images } = await requestSmartRemoveImage({
      images: [getImageOssPath(element.url)],
      masks: [maskImageId],
      ...inferenceAPIBucket,
    });

    if (Array.isArray(images) && images[0]) {
      notifySuccess(translate('smartremove_success'));
      updateElement(element.id, { url: getCDNImage(images[0]) });
      return getCDNImage(images[0]);
    } else {
      throw new Error(translate('smartremove_fail_toast_content'));
    }
  } catch (error) {
    notifyError(translate('smartremove_fail_toast_title'), error.message);
  } finally {
    stopLoading(element.id + '-removing');
  }

  // 将生成图片的url返回
  return;
};
